module.exports = __webpack_public_path__ + "static/media/eco-ecology-leaf-3-svgrepo-com.5009cf5b.svg";